import { getBetStatistics } from "../Service";
import { ProgressbarPartType } from "../BetDistribution/MultiPartProgressbar.types";

type BetStatisticsResponseType = {
    draw: number;
    teamAwayLabel: string;
    teamAwayWin: number;
    teamHomeLabel: string;
    teamHomeWin: number;
};

const MIN_VALUE = 5;

function mapValues(values: number[]) {
    values[0] = Math.max(values[0], MIN_VALUE);
    values[1] = values[1] === 0 ? 0 : Math.max(values[1], MIN_VALUE);
    values[2] = Math.max(values[2], MIN_VALUE);

    const extra = values[0] + values[1] + values[2] - 100;
    if (extra > 0) {
        const maxValue = Math.max(...values);
        const maxValueIndex = values.findIndex((value) => value === maxValue);

        values[maxValueIndex] -= extra;
    }

    return values;
}

export function getMappedBetStatistics(
    postId: string,
): Promise<ProgressbarPartType[]> {
    return getBetStatistics(postId).then((data: BetStatisticsResponseType) => {
        const teamHomeLabel = data.teamHomeWin + "% " + data.teamHomeLabel;
        const teamAwayLabel = data.teamAwayWin + "% " + data.teamAwayLabel;
        const drawLabel = data.draw + "% X";
        const newValues = mapValues([
            data.teamHomeWin,
            data.draw,
            data.teamAwayWin,
        ]);
        const labels = [teamHomeLabel, drawLabel, teamAwayLabel];
        const barsData: ProgressbarPartType[] = [];

        newValues.forEach((value, index) => {
            if (value) {
                barsData.push({
                    value: value,
                    label: labels[index],
                });
            }
        });

        return barsData;
    });
}
